import React from 'react';
import * as R from 'ramda';
import styles from './css/AllInvoices.scss';
import Card from '@mui/material/Card';
import CardHeaderCD from '../../component/CardHeaderCD';
import { store } from '../store';
import getHistoryListDefaultHOCEnhance from './../../main/HistoryListDefaultHOC';
import HistoryList from '../../main/HistoryList';
import { CardContent } from '@mui/material';
import { withProps } from 'react-recompose';
import AppIcon from '@mui/icons-material/SettingsApplications';

const AppList = R.compose(
	getHistoryListDefaultHOCEnhance({
		store,
		method: 'GET',
		url: '/get/all/apps',
		options: { reactQuery: { queryName: 'getAllApps' } }
	}),
	withProps({
		onIcon: () => <AppIcon />
	})
)(HistoryList);

const Apps = props => {
	return (
		<div className={styles.wrap}>
			<Card>
				<CardHeaderCD title="APPS" />
				<CardContent>
					<AppList />
				</CardContent>
			</Card>
		</div>
	);
};
export default Apps;
